import {useQuery} from "react-query";
import {getNewsCategories} from "../Api/api";

const QUERY_KEY = 'news-categories'

export const useGetNewsCategories = () => {
  return useQuery(
    QUERY_KEY,
    async () => getNewsCategories()
  );
}